import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useGetTechnicalWorkQuery } from "../../technical/technicalApi";
import { dateRanges } from "../dashboardHelpers";

// Shared by ClientRequestsKpi and ClientRequestsOverviewChart - both derive
// the same status buckets from the same Technical Work fetch (RTK Query
// dedupes the underlying request), so the bucketing logic itself lives
// here once instead of being copied into both widgets.
//
// Sourced from the Technical module's "Service" group only (Complaints +
// Service Visits) - Installation work is Sales-Order/project-driven, not a
// customer "request". "Urgent" from the original mockup has no real
// backing field on App_TechnicalWork, so "Overdue" (ExpectedCompletionDate
// already passed, still not complete) is used instead - real data, not an
// invented flag.
export const useClientRequestsBreakdown = () => {
  const hasView = useHasPermission("Technical.View");
  const hasViewComplaints = useHasPermission("Technical.ViewComplaints");
  const hasViewServiceVisits = useHasPermission("Technical.ViewServiceVisits");
  const canView = hasView || hasViewComplaints || hasViewServiceVisits;
  const { selectedBranchId } = useBranchFilter();
  const dr = dateRanges();

  const { data, isFetching } = useGetTechnicalWorkQuery(
    { branchId: selectedBranchId ?? undefined, sourceGroup: "SERVICE", pageSize: 500 },
    { skip: !canView }
  );

  const items = data?.items || [];
  const notStarted = items.filter((w) => w.status === "NOT_STARTED").length;
  const inProgress = items.filter((w) => ["ASSIGNED", "ONGOING", "ON_HOLD"].includes(w.status)).length;
  const completedToday = items.filter((w) => w.status === "COMPLETED" && w.completedDate?.slice(0, 10) === dr.today).length;
  const overdue = items.filter((w) => w.expectedCompletionDate?.slice(0, 10) < dr.today && w.status !== "COMPLETED").length;

  return {
    canView,
    isFetching,
    notStarted,
    inProgress,
    completedToday,
    overdue,
    openRequests: notStarted + inProgress,
  };
};
